"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// styles
require("./styles/register.scss");
var controllers_1 = require("./controllers");
var services_1 = require("./services");
var routes_1 = __importDefault(require("./config/routes"));
/**
 * @ngdoc module
 * @module rinca.apps.discount
 * @name rinca.apps.discount
 * @packageName rinca.apps
 * @description A module that includes the discount component.
 */
exports.default = angular.module('rinca.core.register', ['ui.router'])
    .controller('RegisterController', controllers_1.RegisterController)
    .service('_register', services_1.RegisterService)
    .config(routes_1.default);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/register/index.js
// module id = 321
// module chunks = 0